<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3" >

      <v-data-table
        class="mb-3 mx-3"
        :search="search"
        :headers="headers"
        :items="masters"
        :item-class="
          (item) => (item.isDeleted ? 'deleted clickable-row' : 'clickable-row')
        "
        no-data-text="Пусто"
        no-results-text="Результатов нет"
        @click:row="editMaster"
        hide-default-footer
        :custom-sort="customSort"
        sort-by="id"
        :sort-desc="true"
        :loading="tableLoading"
        loading-text="Загрузка"
        :items-per-page="10"
      >

      <template v-slot:top="{ pagination, options, updateOptions }">
        <div fluid class="mb-0 pb-0 justify-start ">    
            <v-row class="align-center">
              <v-btn v-if="$store.getters.user.roleId === 0" color="green" dark to="/masters/add" class="mr-3 ml-3">
                <v-icon>mdi-plus</v-icon>
                Добавить
              </v-btn>
              
              <v-checkbox v-model="showingDeleted" color="green" label="Удаленные" class="mr-3"/>
              <v-checkbox v-model="hideExpired" color="green" label="Закончившиеся" class="mr-3"/>
              <v-checkbox v-model="showingShowrooms" color="green" label="Шоурумы" class="mr-3"/>
              <v-spacer/>
              <v-menu  color="green" offset-y v-if="$store.getters.user.roleId === 0">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="mr-3" text>
                    <v-icon>mdi-file-download</v-icon>
                    Выгрузить в файл
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="exportToFile('csv')">csv</v-list-item>
                  <v-list-item @click="exportToFile('xlsx')">xlsx</v-list-item>
                </v-list>
              </v-menu>
            </v-row>

            <v-row align="center" no-gutters class="pt-0 mt-0">
              <v-text-field
                v-if="$store.getters.dealers"
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Поиск" 
                single-line
                hide-details
                class="pt-0 pb-0 mb-0 pt-5"
              />
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                :items-per-page-options="[10, 50, 100, -1]"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              >
              </v-data-footer>
            </v-row>
          </div>
        </template>

        <template v-slot:header.id="{ header }">
          <span v-html="header.text"></span>
        </template>

        <template v-slot:header.count="{ header }">
          <span v-html="header.text"></span>
        </template>

        <template v-slot:item.expires="{ item }">
          <span :class="{ expired: (new Date()).setHours(0,0,0,0) > new Date(item.expires) }">
            <v-badge v-if="item.isSosActivated" color="red" content="SOS">{{
              new Date(item.expires).toLocaleDateString()
            }}</v-badge>
            <template v-else>{{
              new Date(item.expires).toLocaleDateString()
            }}</template>
          </span>
        </template>
        <template v-slot:item.count="{ item }">
          <span>{{item.count}} | </span>
          <span v-if="item.licensesCount" class="red--text">
            {{item.licensesCount}}
          </span>
          <span v-else class="red--text"> 0</span>
           | 
          <span class="green--text">{{item.count-item.licensesCount }} </span>
        </template>
        <template v-slot:item.moneyFor="{ item }">
          <span v-if="item.showroom">Никому, это шоурум</span>
          <span v-else-if="item.moneyFor != null && $store.getters.mappedOurLegalEntities[item.moneyFor]">{{
            $store.getters.mappedOurLegalEntities[item.moneyFor].name }}</span>
          <span v-else>Не задано</span>
        </template>
        <template v-slot:item.showroom="{ item }">
          <v-simple-checkbox :value="item.showroom"/>
        </template>
        <template
          v-if="$store.getters.user.roleId === 0"
          v-slot:item.actions="{ item }"
        >
          <v-tooltip v-if="!item.isDeleted" top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="deleteMasterConfirm(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>

          <v-tooltip v-else top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="restoreMaster(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-backup-restore
              </v-icon>
            </template>
            <span>Восстановить</span>
          </v-tooltip>
        </template>
        <template v-slot:item.updateTime="{ item }">
          <span>{{ formatUpdateTime(item.updateTime) }}</span>
        </template>
      </v-data-table>
    </v-card>

    <confirmation-dialog
      ref="confirmation"
      title="Удаление Мастер-лицензии"
      agree-button="Удалить"
      disagree-button="Отмена"
      @agree="deleteMaster($event)"
    ></confirmation-dialog>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import ConfirmationDialog from "@/components/ConfirmationDialog";

import FormatDateTime from "@/utils/time.js";

export default {
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      deletingMasterId: "",

      tableLoading: true,
      search: "",
      showingDeleted: false,
      showingShowrooms: true,
      hideExpired: false,
    };
  },
  methods: {
    exportToFile(format) {
      const showingDeleted = this.showingDeleted;
      const showingShowrooms = this.showingShowrooms;
      const hideExpired = this.hideExpired;
      API.get(`masters/reports?format=${format}&showingDeleted=${showingDeleted}&showingShowrooms=${showingShowrooms}&hideExpired=${!hideExpired}`, { responseType: 'blob' })
        .then(response => {
          if (response.status === 200) {
            let contentType = '';
            let fileExtension = '';
            if (format === 'csv') {
              contentType = 'text/csv';
              fileExtension = '.csv';
            } else if (format === 'xlsx') {
              contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              fileExtension = '.xlsx';
            }
            const blob = new Blob([response.data], { type: contentType });
            const date = new Date();
            const currentDate = this.formatUpdateTime(date);
            const filename = `Отчет мастер-лицензии ${currentDate}${fileExtension}`.replace(/:/g, '.');
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
            }
            console.log('Файл успешно загружен');
          } else {
            console.error('Ошибка загрузки файла:', response.statusText);
          }
        })
        .catch(error => {
          console.error('Ошибка загрузки файла:', error);
        });
    },
    customSort(items, index, isDesc) {
      if (index[0] === "expires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.expires) > new Date(b.expires) ? 1 : -1;
          } else {
            return new Date(a.expires) > new Date(b.expires) ? -1 : 1;
          }
        });
      } else {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return a[index[0]] > b[index[0]] ? 1 : -1;
          } else {
            return a[index[0]] > b[index[0]] ? -1 : 1;
          }
        });
      }
      return items;
    },
    editMaster(master) {
      if (this.$store.getters.user.roleId > 0) return;

      if (master.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Мастер-лицензия удалена",
        });
      } else {
        this.$router.push("/masters/" + master.id);
      }
    },
    deleteMasterConfirm(master) {
      this.deletingMasterId = master.id;
      this.$refs.confirmation.showDialog(
        master.id,
        `Вы действительно хотите удалить Мастер-лицензию на Модуль <span class="highlighted">${master.moduleName}</span> для Объекта <span class="highlighted">${master.objectName}</span> ?`
      );
    },
    deleteMaster(masterId) {
      API.get(`masters/${masterId}/delete`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateMasters");
          this.$store.dispatch("updateLicenses");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    restoreMaster(master) {
      API.get(`masters/${master.id}/restore`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateMasters");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  computed: {
    masters: function () {
      return this.$store.getters.masters
        .filter((master) => (this.showingDeleted ? true : !master.isDeleted))
        .filter((master) => this.showingShowrooms || !master.showroom)
        .filter((master) => this.hideExpired || new Date(master.expires) > (new Date()).setHours(0,0,0,0));
    },
    headers: function () {
      let allHeaders = [
        {
          text: "Код <br>мастер-лицензии",
          align: "start",
          value: "id",
        },
        {
          text: "Кол-во лицензий <br>всего | использовано | свободно",
          align: "start",
          value: "count",
        },
        {
          text: "Объект",
          align: "start",
          value: "objectName",
        },
        {
          text: "Дилер",
          align: "start",
          value: "dealerName",
        },
        {
          text: "Модуль ПО",
          align: "start",
          value: "moduleName",
        },
        {
          text: "Деньги кому?",
          align: "start",
          value: "moneyFor",
          width: 140,
          sortable: false,
          superAdminOnly: true,
        },
        {
          text: "Шоурум",
          align: "center",
          value: "showroom",
          sortable: false,
        },
        {
          text: "Max Date",
          align: "center",
          value: "expires",
        },
        {
          text: "Изменил",
          align: "center",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
        {
          text: "Действия",
          align: "center",
          value: "actions",
          sortable: false,
          superAdminOnly: true,
        },
      ];

      return allHeaders.filter(
        (h) => !h.superAdminOnly || this.$store.getters.user.roleId === 0
      );
    },
  },
  activated() {
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "masters", disabled: true },
    ]);
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch("updateMasters"),
      this.$store.dispatch("updateMappedOurLegalEntities"),
    ])
    this.tableLoading = false
  },
};
</script>

<style>
.deleted {
  background-color: #e5d4d4;
}

.expired {
  background-color: #eccdcd;
  color: #000000;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
}
</style>
